export const pageTitleStoreKey = 'pageTitle';
